/**
 * Tick-based countdown — calls `onTick` every second with the remaining
 * whole-seconds, and `onComplete` once it hits zero. Cancellable.
 */
export class CountdownTimer {
  private intervalId: number | null = null;
  private endsAt = 0;

  start(durationMs: number, opts: {
    onTick: (sec: number) => void;
    onComplete: () => void;
  }): void {
    this.stop();
    this.endsAt = performance.now() + durationMs;
    opts.onTick(Math.ceil(durationMs / 1000));
    this.intervalId = window.setInterval(() => {
      const remaining = Math.max(0, this.endsAt - performance.now());
      const sec = Math.ceil(remaining / 1000);
      opts.onTick(sec);
      if (remaining <= 0) {
        this.stop();
        opts.onComplete();
      }
    }, 250);
  }

  stop(): void {
    if (this.intervalId != null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
